import { useParams } from "react-router-dom";
import { ETableEditAction } from "../../../Utils/Enums";
import { endpoints } from "../../../Utils/UrlEnum";
import MUIDataTableCustomStyle from "../../MUIDataTableCustomStyle";
import { Vocabulary } from "../../../Utils/Vocabulary";
import { formatDate, OrderStatus } from "../../../Utils/Utils";
import { TriggerReloadProps } from "../../../Utils/Types";

export default function ExamnsTable(
  props: TriggerReloadProps & { product?: any; clientId?: any },
) {
  const { id } = useParams();
  const { triggerReload, product, clientId } = props;

  // data url
  const certificateProdEndPoint = `${endpoints.exams.certificateExamsForClient}`
    .replace(":clientId", clientId || "")
    .replace(":orderId", id || "");
  const schoolProdEndPoint = `${endpoints.exams.forOrder}/${id}`;
  const endPointUrl = product?.isCertificate
    ? certificateProdEndPoint
    : schoolProdEndPoint;

  /**
   *
   */
  const columns = [
    {
      label: ` `,
      name: "_id",
      options: {
        sort: false,
        display: false,
      },
    },
    {
      label: Vocabulary.id,
      name: "incrementId",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.examType,
      name: "type",
      options: {
        sort: false,
        customBodyRender: (object: any) => {
          return product?.isCertificate ? OrderStatus.certificate : object;
        },
      },
    },
    {
      label: Vocabulary.examDate,
      name: "examDate",
      options: {
        sort: false,
        customBodyRender: (object: any) => {
          return formatDate(object);
        },
      },
    },
    {
      label: Vocabulary.createdAt,
      name: "enrolledAt",
      options: {
        sort: false,
        customBodyRender: (object: any) => {
          return formatDate(object);
        },
      },
    },
  ];
  return (
    <div>
      <MUIDataTableCustomStyle
        CRUDEndPoint={endPointUrl}
        title={""}
        onEditAction={ETableEditAction.NONE}
        columns={columns}
        triggerReload={triggerReload}
        hideEditButton
        hideDeleteButton
        hideAddButton
        hideSearch
        // triggerReload={triggerReload}
      />
    </div>
  );
}
